import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

@Component({
  selector: "expand-tile-table",
  templateUrl: "./expand-tile-table.component.html",
  styleUrls: ["./expand-tile-table.component.scss"],
})
export class ExpandTileTableComponent implements OnInit {
  @Input() data;
  @Input() displayedColumns;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  dataSource;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(change) {
    if (change && change.data) {
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.sort = this.sort;
      this.customSort();
    }
  }

  customSort() {
    this.dataSource.sortingDataAccessor = (item, property) => {
      if (
        (item[property] === "" || item[property] === null) &&
        this.sort.direction == "asc"
      ) {
        // sort blank/null values to the bottom while in asc order, instead of default, where they would display at the top
        return "ZZ";
      } else {
        return item[property] ? item[property] : null;
      }
    };
  }

  clearTableSort() {
    this.sort.sort({ id: "Course", start: "asc", disableClear: false });
    this.sort.direction = "asc";
  }
}
